import { useEffect, useState, type ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useSharedAuth } from '@litopia/shared';

function createOppQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
        retry: 1,
      },
      mutations: {
        retry: false,
      },
    },
  });
}

function AccountQueryRuntime({ children }: { children: ReactNode }) {
  const [queryClient] = useState(createOppQueryClient);

  useEffect(() => () => queryClient.clear(), [queryClient]);

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}

/**
 * A QueryClient per signed-in account: signing out or switching accounts drops
 * the previous account's cached letters instead of showing them to the next user.
 */
export function OpenPenPalRuntimeProviders({ children }: { children: ReactNode }) {
  const { user, loading } = useSharedAuth();

  if (loading) return null;

  return (
    <AccountQueryRuntime key={user?.id ?? 'anonymous'}>
      {children}
    </AccountQueryRuntime>
  );
}
